export type FilterOption = string | { value: string; label: string };

/**
 * Compact labelled dropdown for list-filter rows. Options may be plain strings
 * (value === label) or {value,label} pairs (e.g. a lot whose value is its id
 * but label is "Seller · date"). An "All" option is always prepended; its text
 * can be customised via `allLabel`.
 */
export function FilterSelect({
  label,
  value,
  options,
  onChange,
  allLabel = "All",
}: {
  label: string;
  value: string;
  options: FilterOption[];
  onChange: (v: string) => void;
  allLabel?: string;
}) {
  const normalized = options.map((o) =>
    typeof o === "string" ? { value: o, label: o } : o,
  );
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-md border border-border bg-muted px-2.5 py-1.5 text-xs text-foreground focus:outline-none focus:ring-1 focus:ring-primary"
      >
        <option value="All" className="bg-card text-foreground">
          {allLabel}
        </option>
        {normalized.map((o) => (
          <option
            key={o.value}
            value={o.value}
            className="bg-card text-foreground"
          >
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
